import ENV from "@env/index"
import { setAlert } from "@modules/app/reducers/alertReducer"
import { DispatchType } from "@redux/types"
import { jsonToParams } from "@utils/jsonToParams"
import request from "@utils/request"
import { handleResponse } from "@utils/response"
import { ResponsePattern } from "@utils/response/types"
import { CampoDinamico, DadosConvite } from "../interfaces/CampoDinamico"
import { Convite, IGeoLocalizacao } from "../interfaces/Convite"
import { setConvite, setConviteCampos, setDadosConvite, setGeoLocalozacao, setValidateLiveness, setSessionId } from "../reducers/conviteReducer"
import { requestGetSessionIdReducers, requestGetConviteReducers, requestGetConviteCamposReducers, requestSaveConviteReducers, requestGetGeoLocalizacaoReducers, requestValidadeLivenessReducers } from "../reducers/requestConviteReducer"
import CryptoJS from 'crypto-js'

export async function getConviteECampos(dispatch: DispatchType, idEventoConvidado: any) {
    dispatch(requestGetConviteCamposReducers.reset())
    dispatch(requestGetConviteCamposReducers.loading())
    dispatch(requestGetConviteReducers.reset())
    dispatch(requestGetConviteReducers.loading())

    // //CRIPTOGRAFA
    // const key = 'webappAccess&@.1';
    // const encryptedParams = CryptoJS.AES.encrypt(ID_QUE_SERA_CRIPTOGRAFADO.toString(), key).toString();
    // console.log(encryptedParams)
    //DESCRIPTOGRAFA
    const key = 'webappAccess&@.1';
    const decryptedParams = CryptoJS.AES.decrypt(idEventoConvidado, key).toString(CryptoJS.enc.Utf8);
    idEventoConvidado = decryptedParams

    const endpoint = `${ENV.ACCESS_ENDPOINT}/camposDinamicos`
    const params = `?${jsonToParams({ idConvidado: idEventoConvidado })}`
    const response = await request.get<ResponsePattern<{ campos: CampoDinamico[], geoLocalizacao: IGeoLocalizacao, visitante: Convite, dadosConvite: DadosConvite }>>({ endpoint, params })


    handleResponse('getConviteCampos', dispatch, response, requestGetConviteCamposReducers)
        .then(camposConvite => dispatch(setConviteCampos(camposConvite.campos))
        )

    handleResponse('getConvite', dispatch, response, requestGetConviteReducers)
        .then(camposConvite => dispatch(setConvite(camposConvite.visitante))
        )

    handleResponse('getGeoLocalizacao', dispatch, response, requestGetGeoLocalizacaoReducers)
        .then(camposConvite => dispatch(setGeoLocalozacao(camposConvite.geoLocalizacao))
        )

    handleResponse('getGeoLocalizacao', dispatch, response, requestGetGeoLocalizacaoReducers)
        .then(camposConvite => dispatch(setDadosConvite(camposConvite.dadosConvite))
        )
}

export async function saveConvite<T>(dispatch: DispatchType, values: T, idEventoConvidado: number, idConvite: string, idTipoVisita: number, foto: string | null, statusCheck: boolean, tipoEntrada: number, flagFoto: boolean) {

    // if(!foto) return dispatch(setAlert({message:'Tire uma foto', severity:'info'}))
    if (!statusCheck) return dispatch(setAlert({ message: 'Por favor marque a caixa de seleção', severity: 'info' }))
    if (flagFoto && !foto) return dispatch(setAlert({ message: 'Por favor tire uma foto', severity: 'info' }))

    dispatch(requestSaveConviteReducers.reset())
    dispatch(requestSaveConviteReducers.loading())

    const options = { messages: { errorMessage: {}, successMessage: {} } }
    const endpoint = `${ENV.ACCESS_ENDPOINT}/salvar-visitante`
    const body = {
        ...values,
        idVisitante: idEventoConvidado,
        idTipoVisitante: idTipoVisita,
        foto,
        tipoEntrada
    }

    for (const campo in body) if ((body as any)[campo] === '') (body as any)[campo] = null

    const response = await request.post<ResponsePattern<any>>({ authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Mjc5NzgsImlhdCI6MTY3MzI4NDM1NCwiZXhwIjoxNjc1ODc2MzU0fQ.9t265jAevqZjLSYroUEZExie8c0NReOhuwnwnwMkDpU", endpoint, body })
    if (response && !response.flagErro) dispatch(setAlert({ message: 'Dados salvo com sucesso', severity: 'success' }))
    handleResponse('saveConvite', dispatch, response, requestSaveConviteReducers, options).then(() => getConviteECampos(dispatch, idConvite?.replaceAll(' ', '+')))
}

export async function getSessionId(dispatch: DispatchType) {
    dispatch(requestValidadeLivenessReducers.reset())

    dispatch(requestGetSessionIdReducers.reset())
    dispatch(requestGetSessionIdReducers.loading())

    const response = await request.get<ResponsePattern<any>>({ endpoint: `${ENV.ACCESS_ENDPOINT}/sistema/liveness` })

    handleResponse('getSessionId', dispatch, response, requestGetSessionIdReducers)
        .then(data => {
            dispatch(setSessionId(data.body.sessionId))
        })
}

export async function validateLiveness(dispatch: DispatchType, sessionId: string, idVisitante: string) {
    dispatch(requestValidadeLivenessReducers.reset())
    dispatch(requestValidadeLivenessReducers.loading())

    const key = 'webappAccess&@.1';
    const decryptedParams = CryptoJS.AES.decrypt(idVisitante, key).toString(CryptoJS.enc.Utf8);
    const idEventoConvidado = Number(decryptedParams)

    const body = {
        sessionId,
        idEventoConvidado
    }
    const response = await request.post<ResponsePattern<any>>({ endpoint: `${ENV.ACCESS_ENDPOINT}/sistema/liveness`, body })

    handleResponse('validateLiveness', dispatch, response, requestValidadeLivenessReducers)
        .then(data => {
            dispatch(setValidateLiveness(data))
        })
}